import React from 'react';
import {useDispatch} from 'react-redux';
import {getLatestNews} from '../../../redux/actions/news';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import ViewDesktop from './viewDesktop';
import ViewMobile from './viewMobile';
import {Props} from './model';

export const NewsCarousel: React.FC<Props> = (props) => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getLatestNews());
  }, []);

  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View {...props} />;
};
